<template>
  <div
    class="flex spacing mb-6"
    :style="cssVars"
  >
    <div
      v-for="variant in product.variants"
      :key="variant.title"
      class="relative"
    >
      <collection-product-swatch
        :variant="variant"
        :product="product"
        :size="size"
        :selected="variant.id === selectedVariantId"
        @hoveron="$emit('hoveron', $event)"
        @hoveroff="$emit('hoveroff', $event)"
        @click-swatch="clickSwatch($event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    size: { type: Number, default: undefined },
    space: { type: Number, default: 8 },
    selectedVariantId: { type: Number, default: 0 },
  },
  emits: ['click-swatch', 'hoveron', 'hoveroff'],
  computed: {
    cssVars() {
      return {
        '--space-between': `${this.space}px`,
      }
    },
  },
  methods: {
    clickSwatch($event) {
      this.$emit('click-swatch', $event)
    },
  },
}
</script>

<style scoped>
.spacing > * + * {
  margin-left: var(--space-between);
}
</style>
